import { render, staticRenderFns } from "./IntelligentConsult.vue?vue&type=template&id=74042588&scoped=true&"
import script from "./IntelligentConsult.vue?vue&type=script&lang=js&"
export * from "./IntelligentConsult.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentConsult.vue?vue&type=style&index=0&id=74042588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74042588",
  null
  
)

export default component.exports